import EmailTemplateForm from './emailTemplateForm.container';

export default EmailTemplateForm;
